<template>
    <li
        v-if="logoutLink && (isAuthenticated && userName !=='')"
        :class="classes"
        class="order-medium-3 order-large-2"
        data-test-logoutbutton-wrapper
    >
        <a
            v-if="!isExperienceEditor && logoutLink !== null"
            :href="logoutLink.Url"
            :alt="logoutLink.Alt"
            :class="{ 'secondary': isLarge }"
            :data-clicklabel="logoutLink.Text"
            :data-clickaction="'click-header ' + websiteType"
            data-clickcategory="header"
            class="button small no-top-bottom-padding"
            data-test-logoff-button
            v-html="logoutLink.Text"
        />
        <div
            v-else
            :class="{ 'secondary': isLarge }"
            class="button small no-top-bottom-padding"
            v-html="linkEditorFieldIfPossible(logoutLink)"
        />
    </li>
    <li
        v-else-if="myPageLink"
        class="order-medium-3 order-large-2"
        data-test-loginbutton-wrapper
    >
        <a
            v-if="!isExperienceEditor && myPageLink !== null"
            :href="myPageLink.Url"
            :alt="myPageLink.Alt"
            :class="{ 'secondary': isLarge }"
            :data-clicklabel="myPageTextHtml"
            :data-clickaction="'click-header ' + websiteType"
            data-clickcategory="header"
            class="button small no-top-bottom-padding"
            v-html="myPageTextHtml"
        />
        <div
            v-else
            :class="{ 'secondary': isLarge }"
            class="button small no-top-bottom-padding"
            v-html="linkEditorFieldIfPossible(myPageLink)"
        />
    </li>
</template>
<script>
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';

export default {
    name: 'LoginLogoutElement',
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        isAuthenticated: {
            type: Boolean,
            default() {
                return false;
            }
        },
        classes: {
            type: Object,
            default() {
                return {};
            }
        },
        userName: {
            type: String,
            default() {
                return '';
            }
        },
        logoutLink: {
            type: Object,
            default() {
                return {};
            }
        },
        myPageLink: {
            type: Object,
            default() {
                return {};
            }
        },
        myPageText: {
            type: String,
            default() {
                return '';
            }
        },
        isLarge: {
            type: Boolean,
            default() {
                return true;
            }
        }
    },
    computed: {
        myPageTextHtml() {
            return this.myPageText !== '' ? this.myPageText : this.myPageLink.Text;
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';
 .large {
    .padding-lr {
        padding: 0 $function-menu-padding-lr;
    }

    .no-top-bottom-padding {
        padding: 0 $function-menu-padding-bottom-large;
    }

    .function-menu {
        line-height: $menu-line-height;
    }
    }

.small {
    .padding-lr {
        padding: 0 $function-menu-padding-lr;
    }

    .no-top-bottom-padding {
        padding: 0 $function-menu-padding-bottom-small;
    }

    .function-menu {
        line-height: $menu-line-height;
    }
}
</style>
